import { Pipe, PipeTransform } from '@angular/core';
import { ProjectLanguage } from '../../firestore-models/project-language';

@Pipe({
  name: 'multiFaq',
  standalone: false,
})
export class MultiFaqPipe implements PipeTransform {

  transform(values: Array<{lang_code: string, faq: string}>, languages: Array<ProjectLanguage>,currentLang: string = 'ja'): string {
    let faq: string = '';
    if (!!values) {
      const language = languages.find(lang => lang.lang_code === currentLang);//#216 日本語固定になっているので、admin_lang_modeに従って出し分ける
      // const language = languages[0];
      if (language) {
        for (const value of values) {
          if (language.lang_code === value.lang_code) {
            faq = value.faq;
            break;
          }
        }
      }
    }
    return faq;
  }

}
